export function commandBarItems(
  translator,
  onDeleteInvitationSourceMappingGroup,
  hasGroupSelected,
) {
  return [
    {
      key: 'deleteInvitationSourceMappingGroup',
      name: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingGroup',
      ),
      ariaLabel: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingGroup',
      ),
      iconProps: { iconName: 'Delete' },
      disabled: !hasGroupSelected,
      onClick: onDeleteInvitationSourceMappingGroup,
    },
  ];
}
